<template>
    <!-- Componente para mostar el nombre del dealer en el header -->
    <div
        :class="{ 'mt-2': section === 'footer' }"
        class="w-auto"
    >
        <a
            :href="`${url}/${webpage}/contacto`"
            class="block"
        >
            <!-- <svg class="inline w-4 mr-1" :class="{'text-black': section === 'header', 'text-white': section === 'footer'}" viewBox="0 0 12 16" aria-hidden="true">
                <path d="M6 16a.41.41 0 0 1-.19 0 .47.47 0 0 1-.25-.3L2.07 8.45c-.18-.33-.33-.59-.33-.6l-.29-.66a5.82 5.82 0 0 1-.45-2A5.09 5.09 0 0 1 6 0a5.08 5.08 0 0 1 5 5.15 6 6 0 0 1-.44 2l-.27.62s-.17.32-.35.66l-3.47 7.2A.47.47 0 0 1 6 16zM2.59 7.41s.15.26.32.58L6 14.39 9.09 8l.35-.65.24-.58a4.84 4.84 0 0 0 .37-1.65A4.11 4.11 0 0 0 6 1a4.12 4.12 0 0 0-4 4.15 4.72 4.72 0 0 0 .38 1.64z"></path>
                <path d="M6 8.49a2.91 2.91 0 0 1-2.86-2.95A2.91 2.91 0 0 1 6 2.59a2.91 2.91 0 0 1 2.86 3A2.91 2.91 0 0 1 6 8.49zm0-4.91a2 2 0 0 0 0 3.93 2 2 0 0 0 0-3.93z"></path>
            </svg> -->
            <!-- <img
                v-if="section === 'header'"
                class="inline w-4 mr-1"
                :src="`${url}/images/icons/contact_icon.png`" alt="Contacto">
            <img
                v-else-if="section === 'footer'"
                class="inline w-4 mr-1"
                :src="`${url}/images/icons/contact_icon_white.png`" alt="Contacto"> -->
            <svg
                class="inline w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
                stroke="currentColor"
            >
                <path
                    d="M10.292,4.229c-1.487,0-2.691,1.205-2.691,2.691s1.205,2.691,2.691,2.691s2.69-1.205,2.69-2.691
                        S11.779,4.229,10.292,4.229z M10.292,8.535c-0.892,0-1.615-0.723-1.615-1.615S9.4,5.306,10.292,5.306
                        c0.891,0,1.614,0.722,1.614,1.614S11.184,8.535,10.292,8.535z M10.292,1C6.725,1,3.834,3.892,3.834,7.458
                        c0,3.567,6.458,10.764,6.458,10.764s6.458-7.196,6.458-10.764C16.75,3.892,13.859,1,10.292,1z M4.91,7.525
                        c0-3.009,2.41-5.449,5.382-5.449c2.971,0,5.381,2.44,5.381,5.449s-5.381,9.082-5.381,9.082S4.91,10.535,4.91,7.525z"
                ></path>
            </svg>
            {{ dealerName }}
        </a>
    </div>

</template>

<script>
export default {
    props: ['section', 'dealerName'],
    data() {
        return {
            // dealerName: '',
            url: $('.url').text(),
            webpage: $('.webpage').text(),
        }
    },
    // methods: {
    //     getDealerName() {
    //         axios.get(`${this.url}/${this.webpage}/get-dealer-name`)
    //             .then(resp => {
    //                 this.dealerName = resp.data.dealer_name
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //             })
    //     }
    // },
    // created() {
    //     this.getDealerName()
    // }
}
</script>

<style>

</style>